
// import React, { useEffect, useState } from 'react';
// import Select from 'react-select';
// import { useTranslation } from 'react-i18next';

// import Loading from '@components/Shared/Loader/Loading';
// import { Card, CardFooter, CardHeader } from '@components/card/card';

// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { initReport, getReportPagedData, selectReport, setReportRequest } from '@store/DynamicSlice/reportTableSlice';

// import ReportExportExcelModal, { type ExportColumn } from '@Helper/ReportPaged/ReportExportExcelModal';
// import ReportPagination from '@Helper/ReportPaged/ReportPagination';

// import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';

// /** =========================
//  * REQUEST SHAPE
//  * ========================= */
// type TaxReconciliationReq = {
//   pageIndex?: number;
//   pageSize?: number;
//   froM_DATE?: string | null;
//   tO_DATE?: string | null;
//   brancH_ID?: string | null;
// };

// /** =========================
//  * RESPONSE SHAPE (Array items)
//  * ========================= */
// type RowDto = {
//   brancH_NAME: string | null;
//   documenT_CODE: string | null;
//   category: string | null;
//   aP_INVOICE_TYPES: string | null;
//   transactioN_DATE: string | null;
//   gL_POSTING_DATE: string | null;
//   systeM_VAT: number;
//   financE_VAT: number;
//   amounT_DIFFERENCE: number;
//   diagnostiC_STATUS: string | null;
// };

// const REPORT_KEY = 'RPT_TaxReconciliationPurchase';
// const ENDPOINT = 'FinReports/GetTaxReconciliationPurchase';

// const safe = (v: any, fallback = '—') => (v === null || v === undefined || v === '' ? fallback : String(v));

// const formatNumber = (num: number | null | undefined, digits: number = 2) => {
//   if (num === null || num === undefined) return '0.00';
//   return new Intl.NumberFormat('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(
//     num || 0
//   );
// };

// const isoOrNull = (d: any) => {
//   if (!d) return null;
//   if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) return `${d}T00:00:00.000Z`;
//   if (d instanceof Date) return d.toISOString();
//   return null;
// };

// const cleanNulls = <T extends Record<string, any>>(obj: T): Partial<T> => {
//   const out: any = {};
//   for (const [k, v] of Object.entries(obj)) {
//     if (v === null || v === undefined || v === '') continue;
//     out[k] = v;
//   }
//   return out;
// };

// const getOptId = (opt: any): string | null => {
//   const v = opt?.value ?? opt?.id ?? opt?.ID ?? opt?.key ?? null;
//   return v ? String(v) : null;
// };

// const TaxReconciliationPurchase_Paged: React.FC = () => {
//   const { t, i18n } = useTranslation();
//   const isAr = i18n.language !== 'en';

//   const dispatch = useAppDispatch();

//   // ===== Options Hooks
//   const branchHook = useGetOperatingUnitWithPermission() as any;
//   const OptionsBranches = branchHook?.OperatingUnitOptions ?? branchHook?.OptionsBranches ?? [];
//   const loadingBranches = branchHook?.loading ?? false;

//   // ===== Filters State
//   const [fromDate, setFromDate] = useState<any>(null);
//   const [toDate, setToDate] = useState<any>(null);
//   const [branchFilter, setBranchFilter] = useState<any>(null);

//   const [showExport, setShowExport] = useState(false);

//   // ===== Report state
//   const report = useAppSelector(s => selectReport(s as any, REPORT_KEY));
//   const items = (report?.items ?? []) as RowDto[];
//   const meta = report?.meta ?? null;
//   const loading = report?.loading ?? false;
//   const error = report?.error ?? null;

//   useEffect(() => {
//     const initialRequest: TaxReconciliationReq = {
//       pageIndex: 0,
//       pageSize: 50
//     };

//     dispatch(
//       initReport({
//         reportKey: REPORT_KEY,
//         endpoint: ENDPOINT,
//         initialRequest
//       })
//     );
//   }, [dispatch]);

//   const applyFilters = () => {
//     const prevReq = (((report as any)?.request ?? {}) as TaxReconciliationReq) || {};

//     const nextReq: TaxReconciliationReq = {
//       ...prevReq,
//       pageIndex: 0,
//       pageSize: prevReq.pageSize ?? 50,
//       froM_DATE: isoOrNull(fromDate),
//       tO_DATE: isoOrNull(toDate),
//       brancH_ID: getOptId(branchFilter)
//     };

//     dispatch(setReportRequest({ reportKey: REPORT_KEY, request: cleanNulls(nextReq) as any }));
//     dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
//   };

//   const clearFilters = () => {
//     setFromDate(null);
//     setToDate(null);
//     setBranchFilter(null);

//     const resetReq: TaxReconciliationReq = {
//       pageIndex: 0,
//       pageSize: 50
//     };

//     dispatch(setReportRequest({ reportKey: REPORT_KEY, request: resetReq as any }));
//     dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
//   };

//   // Helper function for styling Diagnostic Status
//   const getStatusBadge = (statusText: string | null) => {
//     if (!statusText) return <span className="text-muted">—</span>;
    
//     if (statusText.includes('مفقودة') || statusText.includes('🚨')) {
//       return <span className="badge bg-danger bg-opacity-10 text-danger border border-danger px-2 py-1">{statusText}</span>;
//     }
//     if (statusText.includes('فارق') || statusText.includes('❌')) {
//       return <span className="badge bg-warning bg-opacity-10 text-warning border border-warning px-2 py-1">{statusText}</span>;
//     }
    
//     return <span className="badge bg-success bg-opacity-10 text-success border border-success px-2 py-1">{statusText}</span>;
//   };

//   // Totals Cards
//   const TotalsCards = () => {
//     if (!meta) return null;

//     return (
//       <div className='row g-3 mb-4'>
//         {/* إجمالي ضريبة النظام */}
//         <div className='col-lg-4 col-md-6'>
//           <Card className='bg-primary bg-opacity-10 border-0 shadow-sm h-100'>
//             <div className='card-body d-flex align-items-center'>
//               <div className='p-3 me-3'>
//                 <i className='fas fa-laptop-code text-primary fa-xl'></i>
//               </div>
//               <div>
//                 <h6 className='text-primary fw-bold mb-1'>{isAr ? 'إجمالي ضريبة النظام' : 'Total System VAT'}</h6>
//                 <h4 className='mb-0 fw-bold'>{formatNumber(meta.total_SYSTEM_VAT)}</h4>
//               </div>
//             </div>
//           </Card>
//         </div>

//         {/* إجمالي ضريبة المالية */}
//         <div className='col-lg-4 col-md-6'>
//           <Card className='bg-success bg-opacity-10 border-0 shadow-sm h-100'>
//             <div className='card-body d-flex align-items-center'>
//               <div className='p-3 me-3'>
//                 <i className='fas fa-file-invoice-dollar text-success fa-xl'></i>
//               </div>
//               <div>
//                 <h6 className='text-success fw-bold mb-1'>{isAr ? 'إجمالي ضريبة المالية' : 'Total Finance VAT'}</h6>
//                 <h4 className='mb-0 fw-bold'>{formatNumber(meta.total_FINANCE_VAT)}</h4>
//               </div>
//             </div>
//           </Card>
//         </div>

//         {/* إجمالي الفروقات */}
//         <div className='col-lg-4 col-md-12'>
//           <Card className='bg-danger bg-opacity-10 border-0 shadow-sm h-100'>
//             <div className='card-body d-flex align-items-center'>
//               <div className='p-3 me-3'>
//                 <i className='fas fa-exclamation-triangle text-danger fa-xl'></i>
//               </div>
//               <div>
//                 <h6 className='text-danger fw-bold mb-1'>{isAr ? 'إجمالي الفروقات' : 'Total Differences'}</h6>
//                 <h4 className='mb-0 fw-bold' dir="ltr">{formatNumber(meta.total_DIFFERENCE)}</h4>
//               </div>
//             </div>
//           </Card>
//         </div>
//       </div>
//     );
//   };

//   const exportColumns: ExportColumn<RowDto>[] = [
//     { headerAr: 'الفرع', headerEn: 'Branch', value: r => r.brancH_NAME || '' },
//     { headerAr: 'رقم المستند', headerEn: 'Document Code', value: r => r.documenT_CODE || '' },
//     { headerAr: 'التصنيف', headerEn: 'Category', value: r => r.category || '' },
//     { headerAr: 'نوع فاتورة AP', headerEn: 'AP Invoice Type', value: r => r.aP_INVOICE_TYPES || '' },
//     { headerAr: 'تاريخ الحركة', headerEn: 'Transaction Date', value: r => r.transactioN_DATE ? r.transactioN_DATE.split('T')[0] : '' },
//     { headerAr: 'تاريخ الترحيل', headerEn: 'GL Posting Date', value: r => r.gL_POSTING_DATE ? r.gL_POSTING_DATE.split('T')[0] : '' },
//     { headerAr: 'ضريبة النظام', headerEn: 'System VAT', value: r => r.systeM_VAT || 0 },
//     { headerAr: 'ضريبة المالية', headerEn: 'Finance VAT', value: r => r.financE_VAT || 0 },
//     { headerAr: 'مقدار الفارق', headerEn: 'Difference', value: r => r.amounT_DIFFERENCE || 0 },
//     { headerAr: 'حالة المطابقة', headerEn: 'Diagnostic Status', value: r => r.diagnostiC_STATUS || '' }
//   ];

//   return (
//     <>
//       <CardHeader className='mb-3'>
//         <div className='row g-2 align-items-center mb-2'>
//           {/* Branch Filter */}
//           <div className='col-lg-3'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold' title={isAr ? 'الفرع' : 'Branch'}>
//                 <i className='fas fa-store text-primary'></i>
//               </span>
//               <Select
//                 isLoading={loadingBranches}
//                 value={branchFilter}
//                 onChange={setBranchFilter}
//                 options={OptionsBranches}
//                 placeholder={isAr ? 'الفرع' : 'Branch'}
//                 isClearable
//                 isSearchable
//                 className='flex-grow-1'
//                 classNamePrefix='react-select'
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </div>
//           </div>

//           {/* Buttons */}
//           <div className='col-lg-9 text-end'>
//             <button
//               className='btn btn-outline-secondary me-2'
//               type='button'
//               onClick={clearFilters}
//               title={t('ClearFilters')}
//             >
//               <i className='fas fa-times fa-fw'></i>
//             </button>
//             <button className='btn btn-theme' type='button' onClick={applyFilters} title={t('ApplyFilters')}>
//               <i className='fas fa-filter fa-fw'></i>
//             </button>
//           </div>
//         </div>

//         <div className='row g-2 align-items-center'>
//           {/* From Date */}
//           <div className='col-lg-3'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-calendar'></i>
//               </span>
//               <input
//                 type='date'
//                 className='form-control'
//                 value={fromDate || ''}
//                 onChange={e => setFromDate(e.target.value)}
//                 placeholder={isAr ? 'من تاريخ' : 'From Date'}
//               />
//             </div>
//           </div>

//           {/* To Date */}
//           <div className='col-lg-3'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-calendar'></i>
//               </span>
//               <input
//                 type='date'
//                 className='form-control'
//                 value={toDate || ''}
//                 onChange={e => setToDate(e.target.value)}
//                 min={fromDate || undefined}
//                 placeholder={isAr ? 'إلى تاريخ' : 'To Date'}
//               />
//             </div>
//           </div>

//           {/* Export */}
//           <div className='col-lg-6 text-end'>
//             <button
//               className='btn btn-outline-success'
//               type='button'
//               onClick={() => setShowExport(true)}
//               title={t('Export')}
//               disabled={loading || items.length === 0}
//             >
//               <i className='fas fa-file-excel fa-fw'></i>
//             </button>
//           </div>
//         </div>
//       </CardHeader>

//       <TotalsCards />

//       <Card className='mb-4'>
//         <Loading loading={loading} error={error}>
//           <div className='table-responsive' style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
//             <table className='table table-hover table-bordered mb-0'>
//               <thead className='sticky-top align-middle' style={{ top: 0, zIndex: 10 }}>
//                 <tr className='bg-theme bg-opacity-25 text-center' style={{ backdropFilter: 'blur(20px)' }}>
//                   <th className='small' style={{ minWidth: 150 }}>{isAr ? 'الفرع' : 'Branch'}</th>
//                   <th className='small' style={{ minWidth: 130 }}>{isAr ? 'رقم المستند' : 'Doc Code'}</th>
//                   <th className='small' style={{ minWidth: 180 }}>{isAr ? 'التصنيف' : 'Category'}</th>
//                   <th className='small' style={{ minWidth: 140 }}>{isAr ? 'نوع فاتورة AP' : 'AP Type'}</th>
//                   <th className='small' style={{ minWidth: 110 }}>{isAr ? 'تاريخ الحركة' : 'Trans Date'}</th>
//                   <th className='small' style={{ minWidth: 110 }}>{isAr ? 'تاريخ الترحيل' : 'GL Date'}</th>
                  
//                   <th className='small text-end' style={{ minWidth: 120 }}>{isAr ? 'ضريبة النظام' : 'System VAT'}</th>
//                   <th className='small text-end' style={{ minWidth: 120 }}>{isAr ? 'ضريبة المالية' : 'Finance VAT'}</th>
//                   <th className='small text-end' style={{ minWidth: 120 }}>{isAr ? 'الفارق' : 'Difference'}</th>
                  
//                   <th className='small' style={{ minWidth: 220 }}>{isAr ? 'حالة المطابقة' : 'Status'}</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {!loading && items.length > 0 ? (
//                   items.map((r, idx) => (
//                     <tr key={r.documenT_CODE || idx} className='align-middle'>
//                       <td className='text-start'>{safe(r.brancH_NAME)}</td>
//                       <td className='text-center fw-bold text-primary'>{safe(r.documenT_CODE)}</td>
//                       <td className='text-center'>{safe(r.category)}</td>
//                       <td className='text-center text-secondary'>{safe(r.aP_INVOICE_TYPES)}</td>
                      
//                       <td className='text-center'>
//                         {r.transactioN_DATE ? r.transactioN_DATE.split('T')[0] : '—'}
//                       </td>
//                       <td className='text-center'>
//                         {r.gL_POSTING_DATE ? r.gL_POSTING_DATE.split('T')[0] : '—'}
//                       </td>
                      
//                       <td className='text-end fw-bold'>{formatNumber(r.systeM_VAT)}</td>
//                       <td className='text-end fw-bold text-success'>{formatNumber(r.financE_VAT)}</td>
//                       <td className={`text-end fw-bold ${r.amounT_DIFFERENCE !== 0 ? 'text-danger' : ''}`} dir="ltr">
//                         {formatNumber(r.amounT_DIFFERENCE)}
//                       </td>
                      
//                       <td className='text-start'>
//                         {getStatusBadge(r.diagnostiC_STATUS)}
//                       </td>
//                     </tr>
//                   ))
//                 ) : !loading ? (
//                   <tr>
//                     <td colSpan={10} className='text-center py-5'>
//                       <div className='text-muted'>
//                         <i className='fas fa-clipboard-check fa-3x mb-3 opacity-50'></i>
//                         <h6>{t('NoData')}</h6>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : null}
//               </tbody>
//             </table>
//           </div>
//         </Loading>

//         <CardFooter>
//           <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
//             <ReportPagination reportKey={REPORT_KEY} maxVisiblePages={3} showItemsPerPage={true} />
//             {!loading && items.length > 0 && (
//               <div className='text-muted small'>
//                 <i className='fas fa-info-circle me-1'></i>
//                 {isAr ? 'عرض' : 'Showing'} {items.length} {isAr ? 'من' : 'of'} {meta?.totalRows || 0}{' '}
//                 {isAr ? 'سجل' : 'records'}
//               </div>
//             )}
//           </div>
//         </CardFooter>
//       </Card>

//       <ReportExportExcelModal
//         show={showExport}
//         onHide={() => setShowExport(false)}
//         reportKey={REPORT_KEY}
//         endpoint={ENDPOINT}
//         columns={exportColumns}
//         exportPageSize={4000}
//         sheetName={({ isAr }) => (isAr ? 'مطابقة ضريبة المشتريات' : 'Purchase Tax Reconciliation')}
//         fileName={({ reportKey }) => `${reportKey}_${new Date().toISOString().slice(0, 10)}.xlsx`}
//       />
//     </>
//   );
// };

// export default TaxReconciliationPurchase_Paged;

import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';

import Loading from '@components/Shared/Loader/Loading';
import { Card, CardFooter, CardHeader } from '@components/card/card';

import { useAppDispatch, useAppSelector } from '@store/hooks';
import { initReport, getReportPagedData, selectReport, setReportRequest } from '@store/DynamicSlice/reportTableSlice';

import ReportExportExcelModal, { type ExportColumn } from '@Helper/ReportPaged/ReportExportExcelModal';
import ReportPagination from '@Helper/ReportPaged/ReportPagination';

import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';

/** =========================
 * REQUEST SHAPE
 * ========================= */
type TaxReconciliationReq = {
  pageIndex?: number;
  pageSize?: number;
  froM_DATE?: string | null;
  tO_DATE?: string | null;
  brancH_ID?: string | null;
};

/** =========================
 * RESPONSE SHAPE (Array items)
 * ========================= */
type RowDto = {
  brancH_NAME: string | null;
  documenT_CODE: string | null;
  category: string | null;
  aP_INVOICE_TYPES: string | null;
  transactioN_DATE: string | null;
  gL_POSTING_DATE: string | null;
  systeM_VAT: number;
  financE_VAT: number;
  amounT_DIFFERENCE: number;
  diagnostiC_STATUS: string | null;
};

const REPORT_KEY = 'RPT_TaxReconciliationPurchase';
const ENDPOINT = 'FinReports/GetTaxReconciliationPurchase';

const safe = (v: any, fallback = '—') => (v === null || v === undefined || v === '' ? fallback : String(v));

const formatNumber = (num: number | null | undefined, digits: number = 2) => {
  if (num === null || num === undefined) return '0.00';
  return new Intl.NumberFormat('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(
    num || 0
  );
};

const isoOrNull = (d: any) => {
  if (!d) return null;
  if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) return `${d}T00:00:00.000Z`;
  if (d instanceof Date) return d.toISOString();
  return null;
};

const cleanNulls = <T extends Record<string, any>>(obj: T): Partial<T> => {
  const out: any = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v === null || v === undefined || v === '') continue;
    out[k] = v;
  }
  return out;
};

const getOptId = (opt: any): string | null => {
  const v = opt?.value ?? opt?.id ?? opt?.ID ?? opt?.key ?? null;
  return v ? String(v) : null;
};

const TaxReconciliationPurchase_Paged: React.FC = () => {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language !== 'en';

  const dispatch = useAppDispatch();

  // ===== Options Hooks
  const branchHook = useGetOperatingUnitWithPermission() as any;
  const OptionsBranches = branchHook?.OperatingUnitOptions ?? branchHook?.OptionsBranches ?? [];
  const loadingBranches = branchHook?.loading ?? false;

  // ===== Filters State
  const [fromDate, setFromDate] = useState<any>(null);
  const [toDate, setToDate] = useState<any>(null);
  const [branchFilter, setBranchFilter] = useState<any>(null);

  const [showExport, setShowExport] = useState(false);

  // ===== Report state
  const report = useAppSelector(s => selectReport(s as any, REPORT_KEY));
  const items = (report?.items ?? []) as RowDto[];
  const meta = report?.meta ?? null;
  const loading = report?.loading ?? false;
  const error = report?.error ?? null;

  useEffect(() => {
    const initialRequest: TaxReconciliationReq = {
      pageIndex: 0,
      pageSize: 50
    };

    dispatch(
      initReport({
        reportKey: REPORT_KEY,
        endpoint: ENDPOINT,
        initialRequest
      })
    );
  }, [dispatch]);

  const applyFilters = () => {
    const prevReq = (((report as any)?.request ?? {}) as TaxReconciliationReq) || {};

    const nextReq: TaxReconciliationReq = {
      ...prevReq,
      pageIndex: 0,
      pageSize: prevReq.pageSize ?? 50,
      froM_DATE: isoOrNull(fromDate),
      tO_DATE: isoOrNull(toDate),
      brancH_ID: getOptId(branchFilter)
    };

    dispatch(setReportRequest({ reportKey: REPORT_KEY, request: cleanNulls(nextReq) as any }));
    dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
  };

  const clearFilters = () => {
    setFromDate(null);
    setToDate(null);
    setBranchFilter(null);

    const resetReq: TaxReconciliationReq = {
      pageIndex: 0,
      pageSize: 50
    };

    dispatch(setReportRequest({ reportKey: REPORT_KEY, request: resetReq as any }));
    dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
  };

  // Helper function for styling Diagnostic Status
  const getStatusBadge = (statusText: string | null) => {
    if (!statusText) return <span className="text-muted">—</span>;
    
    if (statusText.includes('مفقودة') || statusText.includes('🚨')) {
      return <span className="badge bg-danger bg-opacity-10 text-danger border border-danger px-2 py-1">{statusText}</span>;
    }
    if (statusText.includes('فارق') || statusText.includes('❌')) {
      return <span className="badge bg-warning bg-opacity-10 text-warning border border-warning px-2 py-1">{statusText}</span>;
    }
    
    return <span className="badge bg-success bg-opacity-10 text-success border border-success px-2 py-1">{statusText}</span>;
  };

  // Helper function for styling Category Badge
  const getCategoryBadge = (categoryText: string | null) => {
    if (!categoryText) return <span className="text-muted">—</span>;

    if (categoryText.includes('مردود') || categoryText.includes('Return')) {
      return (
        <span className="badge bg-danger bg-opacity-10 text-danger border border-danger px-2 py-1">
          <i className="fas fa-undo me-1"></i> {categoryText}
        </span>
      );
    }
    
    if (categoryText.includes('مشتريات') || categoryText.includes('Purchase')) {
      return (
        <span className="badge bg-primary bg-opacity-10 text-primary border border-primary px-2 py-1">
          <i className="fas fa-shopping-cart me-1"></i> {categoryText}
        </span>
      );
    }

    // Default fallback
    return <span className="badge bg-secondary bg-opacity-10 text-secondary border border-secondary px-2 py-1">{categoryText}</span>;
  };

  // Totals Cards
  const TotalsCards = () => {
    if (!meta) return null;

    return (
      <div className='row g-3 mb-4'>
        {/* إجمالي ضريبة النظام */}
        <div className='col-lg-4 col-md-6'>
          <Card className='bg-primary bg-opacity-10 border-0 shadow-sm h-100'>
            <div className='card-body d-flex align-items-center'>
              <div className='p-3 me-3'>
                <i className='fas fa-laptop-code text-primary fa-xl'></i>
              </div>
              <div>
                <h6 className='text-primary fw-bold mb-1'>{isAr ? 'إجمالي ضريبة المشتريات' : 'Total Purchase VAT'}</h6>
                <h4 className='mb-0 fw-bold'>{formatNumber(meta.total_SYSTEM_VAT)}</h4>
              </div>
            </div>
          </Card>
        </div>

        {/* إجمالي ضريبة المالية */}
        <div className='col-lg-4 col-md-6'>
          <Card className='bg-success bg-opacity-10 border-0 shadow-sm h-100'>
            <div className='card-body d-flex align-items-center'>
              <div className='p-3 me-3'>
                <i className='fas fa-file-invoice-dollar text-success fa-xl'></i>
              </div>
              <div>
                <h6 className='text-success fw-bold mb-1'>{isAr ? 'إجمالي ضريبة المالية' : 'Total Finance VAT'}</h6>
                <h4 className='mb-0 fw-bold'>{formatNumber(meta.total_FINANCE_VAT)}</h4>
              </div>
            </div>
          </Card>
        </div>

        {/* إجمالي الفروقات */}
        <div className='col-lg-4 col-md-12'>
          <Card className='bg-danger bg-opacity-10 border-0 shadow-sm h-100'>
            <div className='card-body d-flex align-items-center'>
              <div className='p-3 me-3'>
                <i className='fas fa-exclamation-triangle text-danger fa-xl'></i>
              </div>
              <div>
                <h6 className='text-danger fw-bold mb-1'>{isAr ? 'إجمالي الفروقات' : 'Total Differences'}</h6>
                <h4 className='mb-0 fw-bold' dir="ltr">{formatNumber(meta.total_DIFFERENCE)}</h4>
              </div>
            </div>
          </Card>
        </div>
      </div>
    );
  };

  const exportColumns: ExportColumn<RowDto>[] = [
    { headerAr: 'الفرع', headerEn: 'Branch', value: r => r.brancH_NAME || '' },
    { headerAr: 'رقم المستند', headerEn: 'Document Code', value: r => r.documenT_CODE || '' },
    { headerAr: 'التصنيف', headerEn: 'Category', value: r => r.category || '' },
    { headerAr: 'نوع فاتورة AP', headerEn: 'AP Invoice Type', value: r => r.aP_INVOICE_TYPES || '' },
    { headerAr: 'تاريخ الحركة', headerEn: 'Transaction Date', value: r => r.transactioN_DATE ? r.transactioN_DATE.split('T')[0] : '' },
    { headerAr: 'تاريخ الترحيل', headerEn: 'GL Posting Date', value: r => r.gL_POSTING_DATE ? r.gL_POSTING_DATE.split('T')[0] : '' },
    { headerAr: 'ضريبة المشتريات', headerEn: 'Purchase VAT', value: r => r.systeM_VAT || 0 },
    { headerAr: 'ضريبة المالية', headerEn: 'Finance VAT', value: r => r.financE_VAT || 0 },
    { headerAr: 'مقدار الفارق', headerEn: 'Difference', value: r => r.amounT_DIFFERENCE || 0 },
    { headerAr: 'حالة المطابقة', headerEn: 'Diagnostic Status', value: r => r.diagnostiC_STATUS || '' }
  ];

  return (
    <>
      <CardHeader className='mb-3'>
        <div className='row g-2 align-items-center mb-2'>
          {/* Branch Filter */}
          <div className='col-lg-3'>
            <div className='input-group'>
              <span className='input-group-text fw-bold' title={isAr ? 'الفرع' : 'Branch'}>
                <i className='fas fa-store text-primary'></i>
              </span>
              <Select
                isLoading={loadingBranches}
                value={branchFilter}
                onChange={setBranchFilter}
                options={OptionsBranches}
                placeholder={isAr ? 'الفرع' : 'Branch'}
                isClearable
                isSearchable
                className='flex-grow-1'
                classNamePrefix='react-select'
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>

          {/* Buttons */}
          <div className='col-lg-9 text-end'>
            <button
              className='btn btn-outline-secondary me-2'
              type='button'
              onClick={clearFilters}
              title={t('ClearFilters')}
            >
              <i className='fas fa-times fa-fw'></i>
            </button>
            <button className='btn btn-theme' type='button' onClick={applyFilters} title={t('ApplyFilters')}>
              <i className='fas fa-filter fa-fw'></i>
            </button>
          </div>
        </div>

        <div className='row g-2 align-items-center'>
          {/* From Date */}
          <div className='col-lg-3'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-calendar'></i>
              </span>
              <input
                type='date'
                className='form-control'
                value={fromDate || ''}
                onChange={e => setFromDate(e.target.value)}
                placeholder={isAr ? 'من تاريخ' : 'From Date'}
              />
            </div>
          </div>

          {/* To Date */}
          <div className='col-lg-3'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-calendar'></i>
              </span>
              <input
                type='date'
                className='form-control'
                value={toDate || ''}
                onChange={e => setToDate(e.target.value)}
                min={fromDate || undefined}
                placeholder={isAr ? 'إلى تاريخ' : 'To Date'}
              />
            </div>
          </div>

          {/* Export */}
          <div className='col-lg-6 text-end'>
            <button
              className='btn btn-outline-success'
              type='button'
              onClick={() => setShowExport(true)}
              title={t('Export')}
              disabled={loading || items.length === 0}
            >
              <i className='fas fa-file-excel fa-fw'></i>
            </button>
          </div>
        </div>
      </CardHeader>

      <TotalsCards />

      <Card className='mb-4'>
        <Loading loading={loading} error={error}>
          <div className='table-responsive' style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
            <table className='table table-hover table-bordered mb-0'>
              <thead className='sticky-top align-middle' style={{ top: 0, zIndex: 10 }}>
                <tr className='bg-theme bg-opacity-25 text-center' style={{ backdropFilter: 'blur(20px)' }}>
                  <th className='small' style={{ minWidth: 150 }}>{isAr ? 'الفرع' : 'Branch'}</th>
                  <th className='small' style={{ minWidth: 130 }}>{isAr ? 'رقم المستند' : 'Doc Code'}</th>
                  <th className='small' style={{ minWidth: 200 }}>{isAr ? 'التصنيف' : 'Category'}</th>
                  <th className='small' style={{ minWidth: 140 }}>{isAr ? 'نوع فاتورة AP' : 'AP Type'}</th>
                  <th className='small' style={{ minWidth: 110 }}>{isAr ? 'تاريخ الحركة' : 'Trans Date'}</th>
                  <th className='small' style={{ minWidth: 110 }}>{isAr ? 'تاريخ الترحيل' : 'GL Date'}</th>
                  
                  <th className='small text-end' style={{ minWidth: 120 }}>{isAr ? 'الضريبة في المشتريات' : 'Purchase VAT'}</th>
                  <th className='small text-end' style={{ minWidth: 120 }}>{isAr ? 'الضريبة في المالية' : 'Finance VAT'}</th>
                  <th className='small text-end' style={{ minWidth: 120 }}>{isAr ? 'الفارق' : 'Difference'}</th>
                  
                  <th className='small' style={{ minWidth: 220 }}>{isAr ? 'حالة المطابقة' : 'Status'}</th>
                </tr>
              </thead>

              <tbody>
                {!loading && items.length > 0 ? (
                  items.map((r, idx) => (
                    <tr key={r.documenT_CODE || idx} className='align-middle'>
                      <td className='text-start'>{safe(r.brancH_NAME)}</td>
                      <td className='text-center fw-bold text-primary'>{safe(r.documenT_CODE)}</td>
                      
                      {/* Category Badge Implementation */}
                      <td className='text-center'>
                        {getCategoryBadge(r.category)}
                      </td>
                      
                      <td className='text-center text-secondary'>{safe(r.aP_INVOICE_TYPES)}</td>
                      
                      <td className='text-center'>
                        {r.transactioN_DATE ? r.transactioN_DATE.split('T')[0] : '—'}
                      </td>
                      <td className='text-center'>
                        {r.gL_POSTING_DATE ? r.gL_POSTING_DATE.split('T')[0] : '—'}
                      </td>
                      
                      <td className='text-end fw-bold'>{formatNumber(r.systeM_VAT)}</td>
                      <td className='text-end fw-bold text-success'>{formatNumber(r.financE_VAT)}</td>
                      <td className={`text-end fw-bold ${r.amounT_DIFFERENCE !== 0 ? 'text-danger' : ''}`} dir="ltr">
                        {formatNumber(r.amounT_DIFFERENCE)}
                      </td>
                      
                      <td className='text-start'>
                        {getStatusBadge(r.diagnostiC_STATUS)}
                      </td>
                    </tr>
                  ))
                ) : !loading ? (
                  <tr>
                    <td colSpan={10} className='text-center py-5'>
                      <div className='text-muted'>
                        <i className='fas fa-clipboard-check fa-3x mb-3 opacity-50'></i>
                        <h6>{t('NoData')}</h6>
                      </div>
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
        </Loading>

        <CardFooter>
          <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
            <ReportPagination reportKey={REPORT_KEY} maxVisiblePages={3} showItemsPerPage={true} />
            {!loading && items.length > 0 && (
              <div className='text-muted small'>
                <i className='fas fa-info-circle me-1'></i>
                {isAr ? 'عرض' : 'Showing'} {items.length} {isAr ? 'من' : 'of'} {meta?.totalRows || 0}{' '}
                {isAr ? 'سجل' : 'records'}
              </div>
            )}
          </div>
        </CardFooter>
      </Card>

      <ReportExportExcelModal
        show={showExport}
        onHide={() => setShowExport(false)}
        reportKey={REPORT_KEY}
        endpoint={ENDPOINT}
        columns={exportColumns}
        exportPageSize={4000}
        sheetName={({ isAr }) => (isAr ? 'مطابقة ضريبة المشتريات' : 'Purchase Tax Reconciliation')}
        fileName={({ reportKey }) => `${reportKey}_${new Date().toISOString().slice(0, 10)}.xlsx`}
      />
    </>
  );
};

export default TaxReconciliationPurchase_Paged;